import type { LeadFormStepFields } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { BasicLeadForm } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { 
	faBuilding as fasBuilding
 } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@ui/format";
import autobind from "autobind-decorator";
import { FormCurrency, FormInput, FormNumber } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";

const MAX_MONEY_AMOUNT = 9_999_999_999;

interface StepFields extends LeadFormStepFields {
	companyName: string;
	companyFoundYear: number;
	netIncome: number;
	loanAmount: number;
}
export class LeadForm extends BasicLeadForm<StepFields> {
	protected renderFields(): ReactNode {
		const { submitState } = this.props;

		return (
			<>
				{super.renderFields()}
				<FormInput
					placeholder="Cégnév"
					name="companyName"
					prepend={<FontAwesomeIcon icon={fasBuilding} />}
					validate={this.validCompanyName}
					disabled={submitState !== undefined}
					required
				/>
				<FormNumber
					placeholder="Cég alapítási éve"
					name="companyFoundYear"
					prepend={<FontAwesomeIcon icon={fasBuilding} />}
					validate={this.validCompanyFoundYear}
					disabled={submitState !== undefined}
					required
				/>
				<FormCurrency
					placeholder="Cég éves árbevétele"
					name="netIncome"
					validate={this.validNetIncome}
					disabled={submitState !== undefined}
					required
				/>
				<FormCurrency
					placeholder="Hitelösszeg"
					name="loanAmount"
					validate={this.validLoanAmount}
					disabled={submitState !== undefined}
					required
				/>
			</>
		);
	}

	@autobind
	private validCompanyName(_companyName: string): string {
		if (!_companyName) {
			return "A cégnév megadása kötelező!";
		}

		const companyName = _companyName?.trim();

		if (companyName.length < 2) {
			return "A cégnév legalább 2 karakterből kell, hogy álljon!";
		}

		if (companyName.length > 40) {
			return "A cégnév legfeljebb 40 karakterből állhat!";
		}
	}

	@autobind
	private validCompanyFoundYear(companyFoundYear: number): string {
		let newCompanyStartYear = companyFoundYear;

		// Csak két számjegyet ad meg, akkor kiegészítjük
		if (companyFoundYear < 50) {
			newCompanyStartYear = 2000 + companyFoundYear;
		} else if (companyFoundYear < 100) {
			newCompanyStartYear = 1900 + companyFoundYear;
		}

		if (newCompanyStartYear < 1800) {
			return "A megadható legalacsonyabb érték 1800!";
		}

		if (newCompanyStartYear > new Date().getFullYear()) {
			return "A cég alapítási éve nem lehet jövőbeli.";
		}

		return undefined;
	}

	@autobind
	private validNetIncome(netIncome: number): string {
		if (isNaN(netIncome)) {
			return "Add meg céged utolsó lezárt üzleti évi árbevételét!";
		}

		if (netIncome < 10_000_000) {
			return "A cég alacsony árbevétele miatt javasoljuk lakossági hitel felvételét.";
		}

		if (netIncome > MAX_MONEY_AMOUNT) {
			return `Az árbevétel megadható maximális értéke ${formatText(MAX_MONEY_AMOUNT, "ft")}`;
		}
	}

	@autobind
	private validLoanAmount(loanAmount: number): string {
		if (!loanAmount || loanAmount <= 0) {
			return "Kérjük, add meg az igényelt hitelösszeget!";
		}
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
